// Telefone ou LID?
//
// Gêmea de `identidadeDoJid` do backend (`backend/src/helpers/ContactJid.ts`),
// com a mesma regra: o WhatsApp identifica contato por LID
// ("185542906003571@lid"), que não é telefone de ninguém e não tem para onde
// discar. Contar dígitos não basta — o LID vem com 15, e um telefone com o
// sufixo do aparelho ("5565...:12@...") também passaria dos 14.
const MIN_DIGITOS_LID = 14;

export const identidadeDoJid = (valor) => {
	const digitos = String(valor || "")
		.split("@")[0]
		.split(":")[0]
		.replace(/\D/g, "");

	if (!digitos) return { numero: "", lid: null };

	const ehLid = /@lid$/i.test(String(valor)) || digitos.length >= MIN_DIGITOS_LID;

	return ehLid
		? { numero: "", lid: `${digitos}@lid` }
		: { numero: digitos, lid: null };
};

export default identidadeDoJid;
